// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Li-z","play":"Mi-z"};